import { getVistaFeatureFlag } from '@99designs/experiments';

// Determines enrollment into the freelance capacity overflow feature gate if a customer meets the required criteria:
// https://console.statsig.com/5Yx4xlMFVM9VTFvZaUwBnI/gates/design_services_capacity_overflow
export async function hasOverflowFeatureFlag(isOverflowEligible?: boolean, isDesignLive?: boolean) {
    return getVistaFeatureFlag('design_services_capacity_overflow', [
        { value: isOverflowEligible, must: true },
        { value: isDesignLive, must: false },
    ]);
}
